import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class GisSettingsService {
  constructor(private http: HttpClient) {}

  public fetchGisSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_GIS`
    return this.http.get(url, {})
  }

  public updateGisSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_GIS`
    return this.http.put(url, payload)
  }
}
